import { Button } from "../ui/button";
import { ArrowRight } from "lucide-react";
import { PriceDisplay } from "./PriceDisplay";
import { BookingLanguage } from "@/types/booking";

interface BottomBarProps {
  totalPrice: number;
  animatePrice: boolean;
  onContinue: () => void;
  selectedProducts: string[];
  translations: {
    continue: string;
    totalPrice: string;
  };
  language: BookingLanguage;
}

export const BottomBar = ({
  totalPrice,
  animatePrice,
  onContinue,
  selectedProducts,
  translations: t,
  language,
}: BottomBarProps) => {
  return (
    <div
      className="fixed bottom-0 left-0 right-0 p-4 bg-white border-t"
      style={{
        paddingBottom: `calc(1rem + env(safe-area-inset-bottom))`,
      }}
    >
      <div className="max-w-[1280px] mx-auto">
        <div className="flex flex-col gap-2">
          <PriceDisplay
            price={totalPrice}
            label={t.totalPrice}
            animatePrice={animatePrice}
            className="px-2"
            language={language}
          />

          <Button
            className="w-full flex items-center justify-center gap-2 bg-gradient-to-br from-[#4C2652] to-[#5C4279] hover:shadow-md text-white"
            onClick={onContinue}
            disabled={selectedProducts.length === 0}
            data-testid="product-continue"
          >
            {t.continue}
            <ArrowRight className="h-4 w-4 text-white" />
          </Button>
        </div>
      </div>
    </div>
  );
};
